import { render, staticRenderFns } from "./TagDerAdmin.vue?vue&type=template&id=7604b64c&"
import script from "./TagDerAdmin.vue?vue&type=script&lang=js&"
export * from "./TagDerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports